import moment from "moment";
import recurssion from '../recurrence.json';

const weeksData = recurssion.days;
const position = recurssion.startby;
const month = recurssion.months;

export const convertToString = (data) => {
    //console.log('------------', data);
    if (data && typeof data === 'string') {
        if (data?.includes('DAILY')) {
            return dailyStructure(data)
        } else if (data?.includes('WEEKLY')) {
            return weeklyStructure(data)
        } else if (data?.includes('MONTHLY')) {
            return monthlyStructure(data)
        } else if (data?.includes('YEARLY')) {
            return yearlyStructure(data)
        }
    }
}

const dailyStructure = (val) => {
    const data = val?.split(';')
    // console.log(data);
    let str = '';
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                if (wordSplit[1] === '1') {
                    str = 'Occurs every day'
                } else {
                    str = `Occurs every ${wordSplit[1]} days`
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                str = `${str} until ${convertDateToLocal(wordSplit[1])}`
            }
        })
    }
    return str;
}

const weeklyStructure = (val) => {
    const data = val?.split(';');
    let str = 'Occurs every $$INTERVAL$$ $$BYDAY$$ $$UNTIL$$';
    if (!val?.includes('UNTIL')) {
        str = str.replace('$$UNTIL$$', ``)
    }
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                if (wordSplit[1] !== '1') {
                    str = str.replace('$$INTERVAL$$', `${wordSplit[1]} weeks on`)
                } else {
                    str = str.replace('$$INTERVAL$$', '')
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYDAY') {
                const week = wordSplit[1].split(',');
                const final = [];
                weeksData.forEach(item => {
                    const n = week?.filter(val => val === item.id);
                    if (n.length > 0) {
                        if (n[0] === item.id) {
                            final.push(item.name);
                        }
                    }
                })
                let dayval = ''
                final?.forEach((val, i, arr) => {
                    if (i + 1 === arr.length) {
                        if (arr.length === 1) {
                            dayval = `${dayval}${val}`
                        } else {
                            dayval = `${dayval} and ${val}`
                        }
                    } else {
                        dayval = `${dayval}${dayval ? ', ' : ''}${val}`
                    }
                })
                str = str.replace('$$BYDAY$$', `${dayval}`)

            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                // str = `${str} until ${convertDateToLocal(wordSplit[1])}`
                str = str.replace('$$UNTIL$$', `until ${convertDateToLocal(wordSplit[1])}`)
            }
        })
    } else {
        str = ''
    }
    return str;
}

const monthlyStructure = (val) => {
    // console.log(val?.includes('BYMONTHDAY'))
    if (val?.includes('BYMONTHDAY')) {
        return mothlyByMonthDay(val);
    } else if (val?.includes('BYDAY')) {
        return mothlyByDay(val);
    }
}

const mothlyByMonthDay = (val) => {
    const data = val?.split(';');
    // console.log(data);
    let str = 'Occurs every $$INTERVAL$$ $$BYMONTHDAY$$ $$UNTIL$$';
    if (!val?.includes('UNTIL')) {
        str = str.replace('$$UNTIL$$', ``)
    }
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                if (wordSplit[1] !== '1') {
                    str = str.replace('$$INTERVAL$$', `${wordSplit[1]} months on`)
                } else {
                    str = str.replace('$$INTERVAL$$', 'month on')
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYMONTHDAY') {
                const day = wordSplit[1] ?? '';
                str = str.replace('$$BYMONTHDAY$$', `day ${day}`)
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                str = str.replace('$$UNTIL$$', `until ${convertDateToLocal(wordSplit[1])}`)
                // console.log(convertDateToLocal(wordSplit[1]))
            }
        })
    } else {
        str = ''
    }
    return str
}

const mothlyByDay = (val) => {
    const data = val?.split(';');
    // console.log(data);
    let str = 'Occurs every $$INTERVAL$$ $$BYSETPOS$$ $$BYDAY$$ $$UNTIL$$';
    if (!val?.includes('UNTIL')) {
        str = str.replace('$$UNTIL$$', ``)
    }
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                if (wordSplit[1] !== '1') {
                    str = str.replace('$$INTERVAL$$', `${wordSplit[1]} months on`)
                } else {
                    str = str.replace('$$INTERVAL$$', 'month on')
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYDAY') {
                const val = weeksData.filter(val => val.id === wordSplit[1]);
                if (val?.length) {
                    str = str.replace('$$BYDAY$$', `${val[0].name}`)
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYSETPOS') {
                // console.log(wordSplit[1])
                const val = position.filter(item => item.id === parseInt(wordSplit[1]));
                // console.log(val)
                if (val?.length) {
                    str = str.replace('$$BYSETPOS$$', `${val[0].name}`)
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                str = str.replace('$$UNTIL$$', `until ${convertDateToLocal(wordSplit[1])}`)
                // console.log(convertDateToLocal(wordSplit[1]))
            }
        })
    } else {
        str = ''
    }
    return str
}

const yearlyStructure = (val) => {
    if (val?.includes('BYMONTHDAY')) {
        return yearlyByMonthDay(val);
    } else if (val?.includes('BYDAY')) {
        return yearlyByDay(val);
    }
}

const yearlyByMonthDay = (val) => {
    const data = val?.split(';');
    // console.log(data);
    let str = 'Occurs every $$INTERVAL$$ $$BYMONTHDAY$$ $$BYMONTH$$ $$UNTIL$$';
    if (!val?.includes('UNTIL')) {
        str = str.replace('$$UNTIL$$', ``)
    }
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                if (wordSplit[1] !== '1') {
                    str = str.replace('$$INTERVAL$$', `${wordSplit[1]} years on`)
                } else {
                    str = str.replace('$$INTERVAL$$', 'year on')
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYMONTHDAY') {
                const day = wordSplit[1] ?? '';
                str = str.replace('$$BYMONTHDAY$$', `day ${day}`)
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYMONTH') {
                const val = month.filter(item => item.id === parseInt(wordSplit[1]));
                //console.log(val)
                if (val?.length) {
                    str = str.replace('$$BYMONTH$$', `of ${val[0].name}`)
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                str = str.replace('$$UNTIL$$', `until ${convertDateToLocal(wordSplit[1])}`)
            }
        })
    } else {
        str = ''
    }
    return str
}

const yearlyByDay = (val) => {
    const data = val?.split(';');
    // console.log(data);
    let str = 'Occurs every $$INTERVAL$$ $$BYSETPOS$$ $$BYDAY$$ $$BYMONTH$$ $$UNTIL$$';
    if (!val?.includes('UNTIL')) {
        str = str.replace('$$UNTIL$$', ``)
    }
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                if (wordSplit[1] !== '1') {
                    str = str.replace('$$INTERVAL$$', `${wordSplit[1]} years on`)
                } else {
                    str = str.replace('$$INTERVAL$$', 'year on')
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYDAY') {
                const val = weeksData.filter(val => val.id === wordSplit[1]);
                if (val?.length) {
                    str = str.replace('$$BYDAY$$', `${val[0].name}`)
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYSETPOS') {
                const val = position.filter(item => item.id === parseInt(wordSplit[1]));
                console.log(val)
                if (val?.length) {
                    str = str.replace('$$BYSETPOS$$', `${val[0].name}`)
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYMONTH') {
                const val = month.filter(item => item.id === parseInt(wordSplit[1]));
                console.log(val)
                if (val?.length) {
                    str = str.replace('$$BYMONTH$$', `of ${val[0].name}`)
                }
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                str = str.replace('$$UNTIL$$', `until ${convertDateToLocal(wordSplit[1])}`)
            }
        })
    }
    return str;
}

const convertDateToLocal = (date) => {
    if (date) {
        const validDate = moment(date, 'YYYY/MM/DDTHH:mm:ssZ', true);
        // console.log(validDate.isValid(), 'valide');
        if (validDate.isValid()) {
            const local = moment.utc(date, 'YYYY/MM/DD HH:mm:ss');
            return local.local().format('MM/DD/YYYY');
        } else {
            const timeZoneDate = new Date(moment(date).format('MM/DD/YYYY'))
            return moment(timeZoneDate).format('MM/DD/YYYY')
            //return moment(date).format('MM/DD/YYYY');
        }
    } else {
        return '';
    }
}